import useConsorcioStore from "../storeModules/useConsorcioStore";
import useUserStore from "../storeModules/useUserStore";
import useInsuranceStore from "../storeModules/useInsuranceStore";
import addMoneyMask from "./addMoneyMask";

const getFinalPaymentValue = () => {
  const { isInsuranceHired, valorPremio } = useInsuranceStore.getState();
  const { selectedPlano } = useConsorcioStore.getState();
  const { userCupom, cupomData } = useUserStore.getState();

  //A primeira parcela já reflete o desconto de campanha (Firebase), quando elegível,
  //independente da flag "desconto" do useInitialConfigStore

  //valor da primeira parcela, sem cupom e sem seguro
  const valorPrimeiraParcelaBruto = selectedPlano.planoValorPagamento;

  //Valor da primeira parcela com seguro
  const valorPrimeiraParcelaSeguro =
    selectedPlano.valorParcelaPrimeiroPagtoComSeguro;

  //Valores com cupom aplicado (já compara com o desconto de campanha, para não empilhar os dois; já considera se seguro existe ou não)
  const cupomAplicavel =
    userCupom && cupomData.valorDescontado && cupomData.cupomMaisVantajoso;
  const valorPrimeiraParcelaCupom = cupomData.valorDescontado;

  let finalPaymentValue = 0;

  //Tem seguro, mas não tem cupom aplicável
  if (isInsuranceHired && !cupomAplicavel) {
    finalPaymentValue = valorPrimeiraParcelaSeguro;
    return addMoneyMask(finalPaymentValue);
  }

  //Tem seguro e tem cupom aplicável
  if (isInsuranceHired && cupomAplicavel) {
    finalPaymentValue = valorPrimeiraParcelaCupom + valorPremio;
    return addMoneyMask(finalPaymentValue);
  }

  //Não tem seguro, mas tem cupom aplicável
  if (!isInsuranceHired && cupomAplicavel) {
    finalPaymentValue = valorPrimeiraParcelaCupom;
    return addMoneyMask(finalPaymentValue);
  }

  //Não tem seguro e não tem cupom, ou o cupom não tem valor descontado
  finalPaymentValue = valorPrimeiraParcelaBruto;
  return addMoneyMask(finalPaymentValue);
};

export default getFinalPaymentValue;
